import { Box, Dialog, InlineNotification } from '@packages/shared';
import { useIntl } from 'react-intl';
import { errorFallbackMessages } from './messages';

export type ErrorFallbackProps = {
  onClose: () => void;
};

export const ErrorFallback = ({ onClose }: ErrorFallbackProps) => {
  const { formatMessage } = useIntl();
  return (
    <Dialog
      dialogContent={
        <Box p={1} maxWidth="54.438rem" m="auto">
          <InlineNotification severity="warning">
            {formatMessage(errorFallbackMessages.notification)}
          </InlineNotification>
        </Box>
      }
      title=""
      open
      handleClose={onClose}
      fullScreen
    />
  );
};
